import React from 'react'
import "./skeleton.css"

const MainSkeleton = ({type,classes}) => {
  return (
    <div className={`skeleton ${type} ${classes}`}>

    </div>
  )
}

export default MainSkeleton